<template>
    <div class="container-fluid">
        <b-card no-body class="my-2">
            <b-card-header class="">
                <b-card-title class="card-title-page-garden-help-default my-1">Schedule

                </b-card-title>
            </b-card-header>
        </b-card>
        <b-card no-body class="calendar-garden-help-card p-3">
            <b-row>
                <b-col>
                    <FullCalendar ref="calendarJobs" :options="calendarOptions" :eventsources="calendarOptions.eventSources"
                        :config="config" />
                </b-col>
            </b-row>
            <b-modal id="job-info-moda-gh" modal-class="modal-garden-help job-modal-garden-help" body-class="px-4 py-3"
                size="sm" centered title="Job Info" title-class="modal-title-garden-help" hide-footer>
                <b-row class="mt-2"><b-col>
                        <p class="job-details-modal-title mb-1">
                            {{ selected_job_customer }}
                        </p>
                    </b-col></b-row>
                <b-row class="mt-2"><b-col>
                        <p class="job-details-modal-subtitle mb-1">
                            <img src="@/assets/images/garden-help/phone-icon.png" />
                            {{ selected_job_customer_phone }}
                        </p>
                    </b-col></b-row>

                <b-row class="mt-2"><b-col>
                        <b-card class="card-transparent-background my-1 py-1 px-0" no-body header="Service Details"
                            header-class="job-details-modal-header p-0">
                            <b-card-body class="p-0">
                                <b-list-group class="jobs-list-group-garden-help row mx-0 px-2" horizontal
                                    v-if="selected_job_services">
                                    <b-list-group-item class="list-item col-xl-6  col-md-6"
                                        v-for="(service, index) in selected_job_services" :key="index">
                                        <span class="check-span">
                                            <font-awesome-icon icon="fa-solid fa-circle-check" /></span>
                                        <p>{{ service.name }}</p>
                                    </b-list-group-item>
                                </b-list-group></b-card-body>
                        </b-card>
                    </b-col></b-row>
                <b-row class="mt-2"><b-col>
                        <b-card class="card-transparent-background my-1 py-1 px-0" no-body header="Contractor"
                            header-class="job-details-modal-header p-0">
                            <b-card-body class="p-0">
                                <b-card-text class="job-details-modal-subtitle pl-2 ">
                                    {{ selected_job_contractor }}
                                </b-card-text>
                            </b-card-body>
                        </b-card>
                    </b-col></b-row>
                <b-row class="mt-2"><b-col>
                        <router-link :to="'/garden_help/jobs/view_job/' + selected_job_id" target="_blank"
                            class="btn btn-bumblebee btn-garden-help btn-garden-help-primary float-end">
                            More details
                        </router-link>

                    </b-col></b-row>
            </b-modal>
        </b-card>
    </div>
</template>   
<script>
import axios from "axios";
import $ from "jquery";

import "@fullcalendar/core/vdom"; // solves problem with Vite
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";

import moment from "moment";

export default {
    name: "GardenHelpJobsBoard",
    components: { FullCalendar },
    data() {
        let tempvue = this;
        return {
            show_overlay: false,
            client_name: "GARDENHELP",
            jobs: [],

            selected_job_id: null,
            selected_job_customer: null,
            selected_job_customer_phone: null,
            selected_job_services: [],
            selected_job_contractor: null,

            user_id: JSON.parse(window.localStorage.getItem("user")).id,


            calendarOptions: {
                plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
                initialView: "dayGridMonth",
                // displayEventTime: true,
                headerToolbar: {
                    // left: 'title',
                    // left:'prev title next',
                    // center: 'agendaDay,agendaWeek,month,agendaYear',
                    // right:'today',
                    left: "prev next title",
                    center: "",
                    right: "dayGridMonth,timeGridWeek,timeGridDay today",
                    // center: 'agendaDay,agendaWeek,month',
                    // right: 'prev,next today'
                },
                eventLimit: true,
                eventorder: "-title",
                dayMaxEvents: 3,
                firstDay: 1,
                responsive: false,
                contentHeight: "auto",
                // Dynamic Event Source
                eventSources: [
                    {
                        events(start, callback) {
                            // console.log(start.start, start.end);
                            // console.log(axios.defaults.baseURL);
                            console.log(moment(start.start).format("yyyy-MM-DD"))
                            console.log(moment(start.end).format("yyyy-MM-DD"), tempvue.user_id)
                            let formData = new FormData();
                            formData.append("from", start.start);
                            formData.append("to", start.end);
                            axios
                                .get(
                                    "jobs/calendar?operator_id=" + tempvue.user_id + "&from=" +
                                    moment(start.start).format("yyyy-MM-DD") +
                                    "&to=" +
                                    moment(start.end).format("yyyy-MM-DD"),
                                    {
                                        headers: {
                                            Accept: "application/json",
                                            "Content-Type": "application/json",
                                            client: "GARDENHELP",
                                            Authorization:
                                                "Bearer " +
                                                JSON.parse(window.localStorage.getItem("user"))
                                                    .access_token,
                                        },
                                    }
                                )
                                .then((response) => {
                                    console.log(response);
                                    let events = response.data;

                                    // console.log(events);
                                    callback(events);
                                })
                                .catch((error) => {
                                    console.log(error)
                                    // console.log(error.response.data.error);
                                    // console.log(error.request);
                                    // console.log(error.message);
                                    // this.$fire({
                                    //   // title: "Title",
                                    //   text: error.response.data.error,
                                    //   type: "error",
                                    //   // timer: 5000,
                                    // }).then((r) => {
                                    //   // console.log(r.value);
                                    // });
                                    // this.loginErrorMessage = error.response.data.error;
                                    // this.showLoginErrorMessage = true;
                                });
                        },
                    },
                ],
                eventDidMount: function (info) { },
                refetchEvents: function (info) {
                    // console.log("===============>>>>>>>>>>>");
                    // console.log(info);
                },
                events: [],
                eventClick: (event) => {
                    console.log("event");
                    console.log(event.event);
                    console.log(event.jsEvent.screenX, event.jsEvent.screenY);
                    console.log(event.event.title, event.event.start, event.event.id);
                    tempvue.getJobDetails(event.event.id)
                },
            },
            config: {
                eventClick: (event) => {
                    // console.log(event);
                },
            },
        }
    },

    mounted() {
        // let user = JSON.parse(window.localStorage.getItem("user"));
        // // console.log(user);
        // // console.log(user.id, user.title);
        // this.user_id = user.id;
        // this.user_title = user.type;
        let user = JSON.parse(window.localStorage.getItem("user"));
        this.user_id = user.id

    },
    methods: {
        getJobDetails(id) {
            axios
                .get("/jobs/jobs/" + id, {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        client: this.client_name,
                        Authorization:
                            "Bearer " +
                            JSON.parse(window.localStorage.getItem("user")).access_token,
                    },
                })
                .then((response) => {
                    console.log(response)
                    console.log(response.data)
                    console.log(response.data.contact)
                    console.log(response.data.services)
                    let job = response.data

                    this.selected_job_id = id
                    this.selected_job_customer = job.contact.name
                    this.selected_job_customer_phone = job.contact.phone
                    this.selected_job_services = job.services
                    this.selected_job_contractor = job.operator.name

                    this.$bvModal.show("job-info-moda-gh");


                    //   this.job_obj = response.data

                    //   console.log(this.job_obj.location_lat, Number(this.job_obj.location_lat))
                    //   this.map_center = { lat: Number(this.job_obj.location_lat), lng: Number(this.job_obj.location_lang) }
                    //   this.job_obj.job_position = { lat: Number(this.job_obj.location_lat), lng: Number(this.job_obj.location_lang) }

                    //   this.show_overlay = false
                });
        }
    }
}


</script>
<style scoped::v-deep>
@import "../styles/garden-help-calendar-styles.css";
</style>


// WEBPACK FOOTER //
// src/projects/garden_help/jobs/Schedule.vue